// settings dtos

export interface RefTypeDto {
  id: number;
  description: string;
}

export interface RefParamsDto {
  code: string;
  description: string;
  refTypeId: number;
}

export interface AcDto {
  nom: string;
  abreviation?: string;
  nomAr?: string;
  ancrage: string | null;
  contact: string | null;
  userIds?: string[];
  tutelId: number | null;
  email: string;
  logo: string | null;
  logoFile?: File;
  istTutel: boolean;
  comId: number | null;
  typeAffCommission: string | null;
  adresse: {
    id?: number;
    tel1: string;
    tel2: string;
    fax: string;
    adresse: string;
    compAdresse: string;
    codePostal: string;
    ville: string;
    paysId: number | null;
  };
}

export interface ContactDto {
  nom: string;
  address: string;
  tel1: string;
  tel2: string;
  email: string;
}

export interface CommitteeDoc {
  id: number;
  name: string;
  alfresco_id: string;
  pathFolder: string;
  fileSize: string;
  alfrescoName: string;
  contentType: string;
  fileExtension: string;
}

export interface CommitteeDto {
  nom: string;
  abreviation?: string;
  nomAr?: string;
  decretCreation: string;
  responsableId: string;
  special: boolean;
  ancrage: string | null;
  comTypeId: number;
  tutelId: number | null;
  theAdresse: {
    id?: number;
    tel1: string;
    tel2: string;
    fax: string;
    adresse: string;
    compAdresse: string;
    codePostal: string;
    ville: string;
    paysId: number | null;
    email: string;
  };
  contact: string | null;
  userIds: any[];
  consellierIds?: any[];
  files?: (File | string)[];
  docIds?: number[];
  docs?: CommitteeDoc[];
}

export interface BankDetailsDto {
  nom: string;
  agence: string;
  rib: string;
  paysId: number;
  local: boolean;
  societeId: number;
}

export interface AddressDto {
  typeId: number;
  address: string;
  societeId: number;
}

export interface CompanyDto {
  nom: string;
  typeId: number;
  nif: string;
  dateNif: Date;
  numCnss: string;
  categorieSoumissionnaireId: number;
  activiteIds?: number[];
}

export interface CompanyContactExtras {
  representantLegal: boolean;
  principal: boolean;
}

export interface CompanyContactDto {
  contact: ContactDto;
  societeContactRequest: CompanyContactExtras;
}

export interface CurrencyDto {
  code: string;
  description: string;
  taux: number;
}

export interface PassingModeDto {
  libelle: string;
  type: passingModeType | null;
  etapes: passingModeStep | null;
  restraint: boolean;
  typeMarchersIds?: number[];
}

export interface DelaisReglementairesDto {
  typeMarcherId: number;
  modePassationId: number;
  delaiPublicationLancement: number;
  delaiLancementAttribution: number;
  delaiAttributionDemarrage: number;
}

export interface ActivityDto {
  libelle: string;
  categorieActiviteId: number;
}

export enum passingModeType {
  INTERNATIONAL = 'INTERNATIONAL',
  NATIONAL = 'NATIONAL',
}

export enum passingModeStep {
  ETAPE_UNIQUE = 'ETAPE_UNIQUE',
  DEUX_ETAPES = 'DEUX_ETAPES',
}

export interface DocType {
  id: number;
  libelle: string;
  code: string;
  description: string;
}

export interface ApprovalTypeDto {
  libelle: string;
  organismeDeDeliveranceAgrementsId: number;
}
